// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"d4fbfdf0","248":"7bc1dbc7","453":"29bf76e5","847":"315aa90d","920":"1d8c1d7b","965":"261cdf68","976":"37130bea"}[chunkId] + ".chunk.js";
};